<script>
    import { translations, current_lang, x_scroll_pos_history, y_scroll_pos_history, installation_notice_status } from '../stores.js';
    import BottomMessageBox from '../components/BottomMessageBox.svelte';
    import InstallNotice from '../components/InstallNotice.svelte';
    import { onMount } from 'svelte';
    import {push} from 'svelte-spa-router'

    onMount(() => {
        $x_scroll_pos_history = null;
        $y_scroll_pos_history = null;
    });

    function open_settings(){
        push("/settings/");
    }
</script>
<header>
    <img id="main-logo" src="img/porijazz_2023_logo.svg" alt="Pori Jazz 2023" />
    <div id="settings-button" on:click={open_settings}>
        <img src="img/icons/gear-solid-white.svg" alt="{$translations["SETTINGS"][$current_lang]}">
    </div>
</header>
<div class="content-container full">
    <div class="no-scroll-container">
        <div class="no-stretch-container">
            <ul id="home-menu">
                <li><a href="#/main-concerts">{$translations["MAIN_CONCERTS"][$current_lang]}</a></li>
                <li><a href="#/other-events">{$translations["OTHER_EVENTS"][$current_lang]}</a></li>
                <li><a href="#/map">{$translations["MAP"][$current_lang]}</a></li>
                {#if $current_lang == "FI"}
                <li><a href="#/eat-and-drink">{$translations["EAT_AND_DRINK"][$current_lang]}</a></li>
                {/if}
                <li><a href="#/news">{$translations["NEWS"][$current_lang]}</a></li>
                <li><a href="#/partners">{$translations["PARTNERS"][$current_lang]}</a></li>
            </ul>
        </div>
    </div>
</div>
<BottomMessageBox />

{#if $installation_notice_status != 1}
    <InstallNotice />
{/if}

<style>
    .content-container, 
    .no-stretch-container, 
    .no-scroll-container{
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
    }

    #main-logo{
		height: 100%;
		width: auto;
	}
    
    #settings-button{
        position: absolute;
        right: 15px;
        cursor: pointer;
    }
    #settings-button img{
        width: 20px;
        height: auto;
        display: block;
        margin: 0;
    }
</style>